import { NetworkConfiguration } from "./index";

export const aptosConfigType = "stream::GlobalConfig";
export const aptosStreamType = "stream::StreamInfo";

const LOCAL_CONFIG = new NetworkConfiguration(
  "localhost",
  "http://0.0.0.0:8080",
  "http://0.0.0.0:8000",
  "contract",
  "backend",
  "backendNet"
);

const DEVNET_CONFIG = new NetworkConfiguration(
  "devnet",
  "https://fullnode.devnet.aptoslabs.io",
  "https://faucet.devnet.aptoslabs.com",
  "0x6b65512795f4cb492e2d8713b3ce1aba624516479c3b7b51a73b91cfa3a5b16f",
  "https://api.moveflow.xyz/api",
  "apt_devnet"
);

const TESTNET_CONFIG = new NetworkConfiguration(
  "testnet",
  "https://fullnode.testnet.aptoslabs.com/v1",
  "https://faucet.testnet.aptoslabs.com",
  "0x85e0c7b86bbea605ab495df331042370b81c9abe94a0a7447c719de549545207",
  "https://testnet.api.moveflow.xyz/api",
  "apt_testnet"
);
// 0x78daa336e5da7dcfef7ed1c3ffc8006dfe0aee460b7c4d28bbd854a93e5afb97
const MAINNET_CONFIG = new NetworkConfiguration(
  "mainnet",
  "https://fullnode.mainnet.aptoslabs.com/v1",
  "",
  "0xd723529c03ef65e7b354419e3388d2c19a97e9fae25e55709a1d34a606a1e002",
  "https://api.moveflow.xyz/api",
  "apt_mainnet"
);

const getNetworkConfiguration = (env: string): NetworkConfiguration => {
  switch (env) {
    case "Localhost":
      return LOCAL_CONFIG;
    case "Devnet":
      return DEVNET_CONFIG;
    case "Testnet":
      return TESTNET_CONFIG;
    case "Mainnet":
      return MAINNET_CONFIG;
    default:
      return LOCAL_CONFIG;
  }
};

const netConfApt = getNetworkConfiguration("Mainnet");

export default netConfApt;
